import React from 'react';

interface CounterItem {
    number: string;
    label: string;
}

const counters: CounterItem[] = [];

const Counter: React.FC = () => {
    return (
        <div className="section-counter-arear">
            <div className="padding-global">
                <div className="container-large">
                    <div className="padding-section-large">
                        <div className="counter-arear-component">
                            <div className="counter-arear-content">
                                {counters.map((counter, index) => (
                                    <div key={index} className="counter-namber-content">
                                        <div className="counter-number-wrapper">
                                            <h2 className="counter-namber">{counter.number}</h2>
                                        </div>
                                        <div className="counter-text">{counter.label}</div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Counter;
